import React, { forwardRef } from 'react';
import { Flex, FlexDirection, type FlexProps } from '../flex/flex.component';

// eslint-disable-next-line react/jsx-props-no-spreading
const Column = forwardRef<HTMLDivElement, FlexProps>((props, ref) => <Flex ref={ref} direction={FlexDirection.Column} {...props} />);

export default Column;
